import React from 'react';
import useTabQueryParam from '../../../hooks/useTabQueryParam';
import TeamMembers from './TeamMembers';
import TeamLeaveRequests from './TeamLeaveRequests';
import TeamResignationRequests from './TeamResignationRequests';

const Team = () => {
  const [activeTab, setActiveTab] = useTabQueryParam('tab', 'members');

  return (
    <div>
      {/* <h2 className="text-lg text-center font-bold mb-4">Team Leave Tracker</h2> */}
      <div className="flex justify-center gap-4 mb-2">
        <button
          className={`px-4 py-2 rounded-t-md font-medium ${activeTab === 'members' ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-800 hover:bg-indigo-100'}`}
          onClick={() => setActiveTab('members')}
        >
          Team Members
        </button>
        <button
          className={`px-4 py-2 rounded-t-md font-medium ${activeTab === 'requests' ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-800 hover:bg-indigo-100'}`}
          onClick={() => setActiveTab('requests')}
        >
          Leave Requests
        </button>
        <button
          className={`px-4 py-2 rounded-t-md font-medium ${activeTab === 'resignations' ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-800 hover:bg-indigo-100'}`}
          onClick={() => setActiveTab('resignations')}
        >
          Resignation Requests
        </button>
      </div>
      <div>
        {activeTab === 'members' ? <TeamMembers /> : activeTab === 'requests' ? <TeamLeaveRequests /> : <TeamResignationRequests />}
      </div>
    </div>
  );
};

export default Team;
